<div class="flex flex-col gap-xl items-center">
  <div class="flex flex-col gap-md text-center">
    <core-icon icon="handyman" class="text-content-action-primary" size="xl"/>
    <h1>Geplante Wartung</h1>
    <p>Wir entschuldigen uns dafür, dass unser Chatbot momentan nicht verfügbar ist. Selbstverständlich bemühen wir
      uns
      den Chatbot schnellst möglichst wieder online zu bringen. Danke für Ihr Verständnis!
    </p>
  </div>
</div>
